import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../api/axiosInstance";
import VendorCarousel from "./vendorCarousel/VendorCarousel";
import { motion } from "framer-motion";


const RecommendedVendor = () => {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const res = await axiosInstance.get("/users/vendors/recommended");
        // console.log("✅ Recommended Vendors:", res.data);

        if (res.data && (res.data.vendors || res.data.data)) {
          setVendors(res.data.vendors || res.data.data);
        } else {
          console.warn("⚠️ Unexpected vendor response:", res.data);
          setError("No vendors found.");
        }
      } catch (err) {
        console.error("❌ Error fetching recommended vendors:", err);
        setError("Failed to fetch recommended vendors.");
      } finally {
        setLoading(false);
      }
    };

    fetchVendors();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-20 bg-gradient-to-br from-cyan-50 via-blue-50 to-sky-50">
        <div className="inline-block animate-spin rounded-full h-8 w-8 border-4 border-[#0097b2] border-t-transparent"></div>
        <p className="mt-4 text-gray-500 font-medium">Loading top experts...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-10 text-red-500 bg-gradient-to-br from-cyan-50 via-blue-50 to-sky-50">
        {error}
      </div>
    );
  }

  if (!vendors.length) {
    return (
      <div className="text-center py-10 text-gray-500 bg-gradient-to-br from-cyan-50 via-blue-50 to-sky-50">
        No recommended experts available.
      </div>
    );
  }

  return (
    <section className="relative bg-gradient-to-br from-cyan-50 via-blue-50 to-sky-50 py-10 overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#0097b2] rounded-full mix-blend-multiply filter blur-3xl animate-blob"></div>
        <div className="absolute bottom-20 right-10 w-72 h-72 bg-[#134DA7] rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000"></div>
      </div>

      {/* Subtle Pattern Overlay */}
      <div className="absolute inset-0 opacity-[0.03]">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, rgb(0, 151, 178) 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        <div className="flex justify-between items-end">
          <motion.h2
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="text-xl md:text-2xl font-semibold text-slate-800"
          >
            Top Rated Experts
          </motion.h2>
        </div>

        <VendorCarousel vendors={vendors} />
      </div>

      <style jsx>{`
        @keyframes blob {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
      `}</style>
    </section>
  );
};

export default RecommendedVendor;
